import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Trafikkmeldinger } from "../../RouteDescription/Trafikkmeldinger";

export default function TrafficMessageListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse && 
      props.roadFeatureResponse.trafficMessages && 
      props.roadFeatureResponse.trafficMessages.length !== 0 &&
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Trafikkmeldinger (${props.roadFeatureResponse?.trafficMessages.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <Trafikkmeldinger roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
      </>
      }
    </>
  )
}